import React, { PropsWithChildren } from "react";
import styles from "./FareCardBase.module.scss";
import clsx from "clsx";

export type FareCardBaseProps = {
  trackingName: string;
  hilighted?: boolean;
  fullHeight?: boolean;
  className?: string;
};

export const FareCardBase: React.FC<PropsWithChildren<FareCardBaseProps>> = ({
  children,
  trackingName,
  hilighted = false,
  fullHeight = true,
  className
}) => {
  return (
    <article
      className={clsx(
        styles.card,
        {
          [styles.hilighted]: hilighted,
          [styles.fullHeight]: fullHeight
        },
        className
      )}
      data-content-name={trackingName}
    >
      {children}
    </article>
  );
};

type FareCardBaseContentProps = {
  padding?: "default" | "small" | "medium";
};
export const FareCardBaseContent: React.FC<
  PropsWithChildren<FareCardBaseContentProps>
> = ({ padding = "default", children }) => {
  return (
    <div
      className={clsx(styles.content, {
        [styles.paddingSmall]: padding == "small",
        [styles.paddingMedium]: padding == "medium"
      })}
    >
      {children}
    </div>
  );
};
